import { Component, OnInit } from '@angular/core';
import { Scene } from '../model/scene';
import { TourApiService } from '../services/tour-api.service';
import { ModalService } from '../services/modal.service';
import { TourService } from '../services/tour.service';
import { EnumAware } from '../decorators/enum-aware.decorator';
import {OptionGroup} from '../model/option-group';
import {OptionDetailService} from '../services/option-detail.service';

@Component({
  selector: 'gt-features-sidebar',
  templateUrl: './features-sidebar.component.html',
  styleUrls: ['./tour.component.css', './features-sidebar.component.css']
})
@EnumAware
export class FeaturesSidebarComponent implements OnInit {

  sceneLabels: string[];
  currentScene: Scene;
  constructor(public apiService: TourApiService,
              public modalService: ModalService,
              private tourService: TourService,
              public optionDetailService: OptionDetailService) { }

  ngOnInit() {
    this.sceneLabels = this.tourService.getSceneLabels(true);
    this.currentScene = this.tourService.tour.findSceneByDisplayName(this.sceneLabels[0]);
  }

  showFeaturesForScene(sceneName: string) {
    this.currentScene = this.tourService.tour.findSceneByDisplayName(sceneName);
  }

  toggleOptionsGroup(group: OptionGroup) {
    group.expanded = !group.expanded;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/features-sidebar.component.ts